import { createFileRoute } from "@tanstack/react-router"

import { GoodsReceiptUploadsTab } from "@/screens/WarehouseReceiving/components"

export const Route = createFileRoute("/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/uploads")({
  component: GoodsReceiptUploadsTab,
})
